var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatusDarker20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Arved",
    transform: "translate(-404.000000, -185.000000)",
    stroke: "#F0B423",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(208.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-5",
    transform: "translate(197.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17948718,2.10526316 L20,2.10526316",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17948718,10 L20,10",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17948718,17.8947368 L20,17.8947368",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1025641,2.10526316 C4.1025641,3.26796842 3.18417436,4.21052632 2.05128205,4.21052632 C0.918390256,4.21052632 0,3.26796842 0,2.10526316 C0,0.942558421 0.918390256,0 2.05128205,0 C3.18417436,0 4.1025641,0.942558421 4.1025641,2.10526316 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1025641,10 C4.1025641,11.1627053 3.18417436,12.1052632 2.05128205,12.1052632 C0.918390256,12.1052632 0,11.1627053 0,10 C0,8.83729474 0.918390256,7.89473684 2.05128205,7.89473684 C3.18417436,7.89473684 4.1025641,8.83729474 4.1025641,10 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1025641,17.8947368 C4.1025641,19.0574421 3.18417436,20 2.05128205,20 C0.918390256,20 0,19.0574421 0,17.8947368 C0,16.7320316 0.918390256,15.7894737 2.05128205,15.7894737 C3.18417436,15.7894737 4.1025641,16.7320316 4.1025641,17.8947368 Z",
    id: "Stroke-11"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusDarker20Px);
export default __webpack_public_path__ + "static/media/Icon_Status_Darker_20px.512e10b65afcd8e89411506c3899da46.svg";
export { ForwardRef as ReactComponent };